import { render } from "./Signup.vue?vue&type=template&id=74941f52&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=74941f52&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Christian\\Documents\\Progetti\\ionic-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74941f52"]])

export default __exports__